import Axios, { AxiosInstance } from 'axios';
import EndpointFactory from 'axios-endpoints';

const API: AxiosInstance = Axios.create({
  baseURL: process.env.VUE_APP_PUBLIFILES,
  headers: {},
});

const Endpoint = EndpointFactory(API);

export const termsOfUseEndpoint = new Endpoint<{}>('/static/outros/termos-de-uso.json?terms=true');
export const policyEndpoint = new Endpoint<{}>('/static/outros/politica-de-privacidade.json?terms=true');
